import { InputGroup, InputLabel, TextInput } from '@components/Common';
import { TruckCarrier } from '@api/queries/inventory';
import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import DetailsInput from './DetailsInput';

interface Props extends WithTranslation {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  truck?: TruckCarrier;
  trafficOut: boolean;
  isDisabled?: boolean;
}

const Truck = ({ isDisabled, onChange, trafficOut, truck, t }: Props) => {
  const {
    licencePlate,
    forwardingCompany,
    billOfLandingNumber,
    destinationAddress,
    receiver,
    reference,
    sourceAddress
  } = truck || {
    licencePlate: '',
    billOfLandingNumber: '',
    forwardingCompany: '',
    destinationAddress: '',
    receiver: '',
    sourceAddress: '',
    reference: ''
  };

  return (
    <>
      <DetailsInput
        name="licencePlate"
        label={t('entry.car.licence_plate')}
        isDisabled={isDisabled}
        value={licencePlate}
        onChange={onChange}
      />
      <DetailsInput
        name="forwardingCompany"
        label={t('entry.car.forwarding_company')}
        isDisabled={isDisabled}
        value={forwardingCompany}
        onChange={onChange}
      />
      <DetailsInput
        name="billOfLandingNumber"
        label={t('entry.car.bill_of_landing_number')}
        isDisabled={isDisabled}
        value={billOfLandingNumber}
        onChange={onChange}
      />
      <DetailsInput
        name="reference"
        label={t('entry.car.reference')}
        isDisabled={isDisabled}
        value={reference}
        onChange={onChange}
      />
      {trafficOut ? (
        <>
          <DetailsInput
            name="destinationAddress"
            label={t('entry.car.destination_address')}
            isDisabled={isDisabled}
            value={destinationAddress}
            onChange={onChange}
          />
          <DetailsInput
            name="receiver"
            label={t('entry.car.receiver')}
            isDisabled={isDisabled}
            value={receiver}
            onChange={onChange}
          />
        </>
      ) : (
        <DetailsInput
          name="sourceAddress"
          label={t('entry.car.source_address')}
          isDisabled={isDisabled}
          value={sourceAddress}
          onChange={onChange}
        />
      )}
    </>
  );
};

export default withTranslation()(Truck);
